/* tslint:disable */

/**
 * Inicializaión de la clase CityInfo, modelo de la información de la ciudad
 * 
 * *Set CityInfo class, city information model*
 * 
 * @access public
 * @type {class}
 */
export class CityInfo {
  /**
   * Número de indentificación de la ciudad
   * 
   * *City identification number*
   * 
   * @type {number} id
   */
  id: number;

  /**
   * Valor de la ciudad, nombre de la ciudad
   * 
   * *City value, city name*
   * 
   * @type {string} value
   */
  value: string;
}

/**
 * Inicializaión de la clase NeighborhoodInfo, modelo de la información del barrio
 * 
 * *Set NeighborhoodInfo class, neighborhood info model*
 * 
 * @access public
 * @type {class}
 */
export class NeighborhoodInfo {
  /**
   * Número de indentificación del barrio
   * 
   * *Neighborhood identification number*
   * 
   * @type {number} id
   */
  id: number;

 /**
   * Valor del barrio, nombre del barrio
   * 
   * *Neighborhood value, Neighborhood's name*
   * 
   * @type {string} value
   */
  value: string;
}

/**
 * Inicializaión de la clase DeliveryTimeInfo, modelo de información del tiempo de entrega
 * 
 * *Set DeliveryTimeInfo class, delivery time info model*
 * 
 * @access public
 * @type {class}
 */
export class DeliveryTimeInfo {
  /**
   * Número de indentificación del elemento del tiempo de entrega
   * 
   * *Delivery Time Element identification number*
   * 
   * @type {number} elementId
   */
  elementId: string;

  /**
   * Valor de la información del tiempo de entrega
   * 
   * *Delivery time info value*
   * 
   * @type {string} value
   */
  value: string;
}

/**
 * Inicializaión de la clase DomicilioModel, modelo de información del domicilio
 * 
 * *Set DomicilioModel class, Domicilio info model*
 * 
 * @access public
 * @type {class}
 */
export class DomicilioModel {
  /**
   * Dirección del domicilio para la entrega
   * 
   * *Domicilio's address to deliver*
   * 
   * @type {string} deliveryAddress
   */
  deliveryAddress: string;

  /**
   * Tiempo de entrega, instancia de la variable como DeliveryTimeInfo
   * 
   * *Delivery time, variable instance as DeliveryTimeInfo*
   * 
   * @type {string} pageTitle
   */
  deliveryTime: DeliveryTimeInfo = new DeliveryTimeInfo();

  /**
   * Validación si se seleccionó un archivo
   * 
   * *File selection validation*
   * 
   * @type {string} pageTitle
   */
  isFileSelected: boolean;
}
